export const API = {
  SEND_OTP: `/common/verify-otp/send-otp`,
  VERIFY_OTP: `/common/verify-otp/verify-otp`,
  UPDATE_PASSWORD: `/common/verify-otp/change-password`,
  APPOINTMENT_FORM: `/website/appointment-form`,
  GET_ALL_APPOINTMENT_REASONS: `/common/masters/appointment-reason`,
  GET_ALL_GENDER: `/common//masters/all-gender`,
  GET_ALL_MATERIAL: `/common//masters/all-material`,
  GET_ALL_FRAME_TYPE: `/common//masters/all-frame-type`,
  GET_ALL_COLOR: `/common//masters/all-color`,
  GET_ALL_SHAPE: `/common//masters/all-shape`,
  GET_FACE_WIDTH: `/common//masters/all-face-width`,
  GET_Lens_Type: `/common//masters/all-lens-type`,
  GET_Addon: `/common//masters/all-addon`,
  GET_PRICERANGE: `/common//masters/all-price-range`,
  GET_PRESCRIPTIONVLUE: `/common/masters/prescription-value`,

  GET_LENSE_PRODUCT: `/common/masters/all-lenase-product`,
  GET_Prescription_Details: `/common/masters/prescription-value`,
  FORGOT_PASSWORD: `/common/auth/forgot-password`,
  USER_SINGUP: `/website/user/sing-up`,
  USER_LOGIN: `/website/user/login`,
  CHECK_USER_EXITS: `/auth/check-exist`,
  GET_USER: `/website/user/get-user`,
  UPDATE_PROFILE: `/website/update-profile`,
  CHANGE_PASSWORD: `/website/user/change-password`,
  USER_ADDRESS: `/website/user-address`,
  MY_ACCOUNT: `/website/user/get-user`,
  MY_ACCOUNT_UPDATE: `/website/user/update-profile`,
  MY_PHOTO_UPDATE: `/common/auth/update-profile-photo`,

  GET_HOME_BANNERS: `/website/home/banner`,
  GET_ALL_BANNERS: `/website/home/all-banner`,
  GET_ADVERTISMENT_BANNERS: `/website/advertisement-banner`,
  GET_COUPONS: `/website/home/all-coupons`,
  GET_Why_Choose_Us: `/website/home/all-whychooseus`,
  GET_What_We_Are: `/website/home/all-what_we_are`,
  GET_Welcome: `/website/home/all-welcome`,
  GET_What_Media_Do: `/website/home/all-what_media_do`,
  GET_Career: `/website/home/all-careers`,
  GET_Careers: `/website/home/all-careers`,
  CAREER_FORM: `/website/career/all-career-form`,
  CONTACT_US: `/website/contact/all-contact-us`,
  GET_Return_Policy: `/website/home/all-returnpolicy`,
  GET_POPULAR_STATUS: `/website/home/all-popular_product`,
  GET_SPECIAL_STATUS: `/website/home/all-special_product`,
  GET_HELP: `/website/home/all-help`,
  GET_PRODUCT_SEARCH: `/website/home/product-search`,

  GET_Bapat_Benifit: `/website/bapat-benifits/benifits`,

  GET_Bapat_Eyeq: `/website/bapat-eyeq/eyeqs`,

  // GET_BLOG_CATEGORY: `/website/blog/all-blogcategory`,
  GET_BLOG: `/website/blog/all-blogs`,
  GET_BLOG_BY_ID: `/website/blog/all-blogsbyid`,
  // GET_LATEST_BLOG: `/website/blog/all-latestblog`,
  // GET_TOP_POST_STATUS: `/website/home/all-top_post_status`,

  REVIEW_RATING: `/website/rating-review`,
  AVG_REVIEW_RATING: `/website/rating-review/avg`,

  GET_ALL_COUNTRIES: `/common/masters/all-country`,
  GET_ALL_STATES: `/common/masters/all-state`,
  GET_ALL_CITIES: `/common/masters/all-city`,
  GET_ALL_PINCODES: `/common/masters/all-pincode`,
  GET_ALL_CATEGORIES: `/common/masters/all-p-category`,

  GET_ALL_SUB_CATEGORIES: `/common/masters/all-subcategory`,
  GET_ALL_CHILD_CATEGORIES: `/common/masters/all-childcategory`,

  GET_Needs: `/common/masters/all-needs`,
  GET_ALL_LENS_OPTION: `/common/masters/lens-option`,
  GET_OFFER_PRODUCT: `/website/home/all-offer-product`,

  GET_HEADER_NEWS: `/website/home/all-header-news`,

  GET_TRENDING_PRODUCT: `/website/home/trending-product`,
  POST_Subscriber: `/website/home/all-Subscriber`,

  GET_SOCIAL_MEDIA: `/common/masters/all-socialmedia`,

  GET_ALL_PRODUCT_CATEGORIES: `/common/masters/all-p-category`,
  GET_ALL_PRODUCT_SUB_CATEGORIES: `/common/masters/all-p-sub-category`,
  GET_ALL_PRODUCT_GROUP_BY_SUB_CATEGORIES: `/website/product/all-product-groupby-category`,
  GET_PRODUCTS: `/website/product/eyeglasses-products`,
  GET_ALL_PRODUCTS: `/website/product/all-products`,
  Tranding_PRODUCTS: `/website/product/tranding-products`,
  Top_PRODUCTS: `/website/product/top-products`,
  GET_PRODUCT: `/website/product`,
  GET_LINKED_PRODUCT: `/website/all-linked-product`,

  POST_REVIEW: `/website/rating-review`,
  GET_ALL_REVIEWS: `/website/rating-review`,
  GET_AVG_REVIEWS: `/website/rating-review/avg`,

  CART: `/website/cart`,
  GET_ALL_CART_WITHOUT_LOGIN: `/website/cart/without-login`,
  CHECk_ITEM_IN_CART: `/website/cart/check`,
  CART_QUANTITY: `/website/cart/quantity`,

  WISHLIST: `/website/wishlist`,
  // Wallet: `/website/wallet`,
  CHECk_ITEM_IN_WISHLIST: `/website/wishlist/check`,

  ORDER: `/website/product-order`,
  ORDER_ADDRESS: `/website/user-address`,
  PaymentOnline: `/website/product-order/payment-online`,
  ORDER_CANCEL: `/website/product-order/product-order-cancel`,
  ORDER_RETURN: `/website//product-order/product-order-return`,

  GET_ALL_CANCEL_REASONS: `/common/masters/all-cancel-reasons`,
  GET_ALL_RETURN_REASONS: `/common/masters/all-return-reasons`,

  GET_ALL_PAYMENT_METHOD: `/common/masters/all-payment-method`,
  GET_ALL_ADDRESS_TYPE: `/common/masters/all-address-type`,

  GET_INDUSTRY: `/common/masters/all-industry`,

  GET_DEPARTMENT: `/common/masters/all-department`,
  GET_COMPANY_SIZE: `/common/masters/all-companysize`,
  GET_APP_SETUP: `/common/masters/app-setup`,

  COUPON_APPLYED: `/website/coupons/valid`,
  COUPON: `/website/coupons`,

  ORDER_CALCULATION: `/website/product-order/calculate`,

  ORDER_STATUS: `/common/masters/all-order-status`,
  SOCIAL_LINK: `/common/masters/social-links`,
  Brandings: `/common/masters/web-all-brands`,
  All_Brand: `/common/masters/all-brands-customerview`,

  GET_ABOUTUS_CONTENT: `/website/about-us/content`,
  GET_ABOUTUS: `/website/about-us`,
  GET_ACH_AND_ACK: "/website/about-us/achievements",
  GET_FOUNDING_FARMERS: "/website/about-us/fouding-farmers",
  CONTACT_US_FORM: `/website/contact_us`,

  GET_Privacy_Policy: `/website/home/all-privacypolicy`,
  GET_Shipping_Policy: `/website/home/all-shiiping-policy`,
  GET_TERM_CONDITION: `/website/home/all-termsandconditions`,
  GET_Shipping_Policy: `/website/home/all-shippingpolicy`,

  GET_SUBFAQ: `/common/masters/all-subfaq`,
  GET_FAQCATE: `/common/masters/all-subfaq`,
  GET_FAQ: `/common/masters/all-faq`,

  CATEGORY_WISE_PRODUCTS: `/website/product/all-product-groupby-category`,

  Web_Banner: `/common/masters/allWebsiteBanner`,

  PRESCRPTION: `/website/prescription`,
  Wallet: `/website/wallet`,
  VTO: `/website/product/all-products`,
};
